import type { LocationGroup } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { locationGroups } from '../../schema/tables/gtfs-schedule/location-groups.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all location groups that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getLocationGroups<Fields extends keyof LocationGroup>(
  query: RowQuery<LocationGroup> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<LocationGroup> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<LocationGroup, Fields>(
    locationGroups,
    query,
    fields,
    orderBy,
    options,
  );
}
